
const digest = '7aec8658418799dcf387c99314291a06a743c06dd97d2e84258c75716cdcca43';
const classes = {"wrapper":"_wrapper_k4iiv_1","content":"_content_k4iiv_13"};
const css = `._wrapper_k4iiv_1 {
  position: fixed;
  z-index: 1000;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.85);
  align-items: center;
  justify-content: center;
}
._wrapper_k4iiv_1 ._content_k4iiv_13 {
  background: #ffffff;
  border-radius: 15px;
  padding: 24px;
  width: 480px;
  max-height: calc(100vh - 60px);
  overflow-y: scroll;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  